import KeyParties from "./KeyParties";
export default KeyParties;
